import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import RefundRequestList from './submodules/list';
import RefundDetails from './submodules/create';

const ListRefundRequestDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.downtimeRefund}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].listRefundRequest]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={RefundRequestList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.downtimeRefund}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].createRefundRequest]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={RefundDetails}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ListRefundRequestDashboard;
